import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Footer } from "@lubbezposrednio-frontend/commons";
import { withModel } from "@lubbezposrednio-frontend/core";
import { LandingHeader } from "./components/LandingHeader/LandingHeader";
import { HomeViewHeader } from "./components/HomeViewHeader/HomeViewHeader";
import { VotingsShowcase } from "./components/VotingsShowcase/VotingsShowcase";
import { OrganizerCTA } from "./components/OrganizerCTA/OrganizerCTA";
import { HowItWorks, Manifesto, ForWhom, TrustSection, FaqPreview, ApiCTA, BlogFeed, MobileHeroSection, PanelShowcase, ExplorerShowcase, DistributedChainSection, OwnNodeSection } from "./components/HomeSections";
import { HomeViewModel } from "./HomeViewModel";

interface HomeViewProps {
  model: HomeViewModel;
}

const HomeView: React.FC<HomeViewProps> = observer(({ model }) => {
  useEffect(() => {
    document.title = "Wiarygodne głosowania online — lubbezpośrednio.pl";
  }, []);

  return (
    <Box w="100%" minH="100vh" bg="background" display="flex" flexDirection="column">
      <LandingHeader overlay />
      <HomeViewHeader votings={model.openSignups.length ? model.openSignups : model.openVotings} />

      <Box as="main" w="100%" flex="1">
        <HowItWorks />
        <MobileHeroSection />
        <Manifesto />
        <PanelShowcase />
        <ForWhom />
        <VotingsShowcase
          title="Głosowania otwarte"
          subtitle="Tu możesz się zapisać albo zagłosować — bez logowania."
          votings={[...model.openSignups, ...model.openVotings]}
          isLoading={model.isLoading}
          emptyText="W tej chwili nie ma otwartych zapisów ani głosowań."
        />
        <OrganizerCTA />
        <FaqPreview />
        <TrustSection />
        <ExplorerShowcase />
        <DistributedChainSection />
        <OwnNodeSection />
        <ApiCTA />
        <BlogFeed />
      </Box>

      <Footer />
    </Box>
  );
});

const HomeViewWithModel = withModel<HomeViewModel>(HomeView, HomeViewModel);

export default HomeViewWithModel;
